import React from 'react';
import { Statistic } from 'antd';
import { FeeCategoryModalProps } from './types';
import { StyledModal, StyledAlert, ModalContentWrapper, ModalStatsGrid } from './Styles';
import { useTheme } from '../../../context/ThemeContext';
import { ThemeProvider } from 'styled-components';
import { getAntdThemeConfig } from '../../../utils/antdTheme';
import { ConfigProvider } from 'antd';
import { FEE_CATEGORY_COLORS } from './constants';

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount || 0);
};

const formatPercentage = (value: number): string => {
  return `${(value || 0).toFixed(1)}%`;
};

const FeeCategoryModal: React.FC<FeeCategoryModalProps> = ({ visible, onClose, categoryData }) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: isDarkMode ? 'dark' : 'light' } as const;
  const antdTheme = getAntdThemeConfig(isDarkMode);
  if (!categoryData) return null;
  const categoryName = categoryData.category.replace(/([A-Z])/g, ' $1').trim();
  const isStripe = categoryData.category === 'stripe';

  return (
    <ConfigProvider theme={antdTheme}>
      <ThemeProvider theme={theme}>
        <StyledModal
          title={`Fee Category Details: ${categoryName}`}
          open={visible}
          onCancel={onClose}
          footer={null}
          width={600}
        >
          <ModalContentWrapper>
            <ModalStatsGrid>
              <Statistic
                title="Total Amount"
                value={categoryData.data.amount}
                formatter={(value) => formatCurrency(Number(value))}
                valueStyle={{ color: FEE_CATEGORY_COLORS[categoryData.category] || undefined }}
              />
              <Statistic
                title="Transaction Count"
                value={categoryData.data.count}
                formatter={(value) => (value || 0).toLocaleString()}
              />
            </ModalStatsGrid>

            <Statistic
              title="Percentage of Revenue"
              value={categoryData.data.percentage}
              formatter={(value) => formatPercentage(Number(value))}
            />

            {isStripe && (
              <StyledAlert
                message="Stripe Processing Fees"
                description="These are the actual fees charged by Stripe for payment processing. Consider passing these costs to customers as 'processing fees' to maintain profitability."
                type="warning"
                showIcon
              />
            )}
          </ModalContentWrapper>
        </StyledModal>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default FeeCategoryModal;
